export function ActionItemsSvg({ fillColor = "#FFFFFF", size = 50 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.5977 11.0001C29.5977 9.8545 30.5449 8.92578 31.7133 8.92578H48.2256C49.394 8.92578 50.3412 9.8545 50.3412 11.0001C50.3412 12.1458 49.394 13.0745 48.2256 13.0745H31.7133C30.5449 13.0745 29.5977 12.1458 29.5977 11.0001Z"
        fill={fillColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.02059 13.8334C1.7339 12.9288 3.01308 12.8005 3.8777 13.5468L7.27528 16.4793L17.7157 3.46167C18.4362 2.56332 19.7164 2.44615 20.575 3.19995C21.4337 3.95375 21.5457 5.29309 20.8252 6.19143L9.40654 20.4288C8.51559 21.5396 6.9352 21.6912 5.86602 20.7684L1.29456 16.8226C0.429929 16.0763 0.307269 14.738 1.02059 13.8334Z"
        fill={fillColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.5977 36.9279C29.5977 35.7822 30.5449 34.8535 31.7133 34.8535H48.2256C49.394 34.8535 50.3412 35.7822 50.3412 36.9279C50.3412 38.0735 49.394 39.0022 48.2256 39.0022H31.7133C30.5449 39.0022 29.5977 38.0735 29.5977 36.9279Z"
        fill={fillColor}
      />
      <rect
        x="2.63087"
        y="30.7033"
        width="14.5205"
        height="14.5205"
        rx="2.07436"
        stroke={fillColor}
        stroke-width="4.14871"
      />
    </svg>
  );
}
